// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"1799f717","296":"f36a91cb","733":"72a2dae7"}[chunkId] + ".chunk.js";
};